import React, {useRef, useState} from 'react';
import styles from './index.module.scss'

export default function AlertWrapper({message}) {
    const [isCopies, setIsCopied] = useState(false);
    const alertRef = useRef(null);


    const copyText = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(alertRef.current.innerHTML).then(function () {
            setIsCopied(true)
        }, function (err) {
            // setAlertError('Could not copy text: ', err);
        });
    };

    return (
        <div className={styles.wrapper}>
            <div ref={alertRef}>
                {message}
            </div>
            <div className={styles.wrapper__copy}>
                {!isCopies && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{cursor: "pointer"}}  onClick={copyText}>
                        <path
                            d="M19 4H1C0.73478 4 0.48043 4.1054 0.29289 4.2929C0.10536 4.4804 0 4.7348 0 5V23C0 23.2652 0.10536 23.5196 0.29289 23.7071C0.48043 23.8946 0.73478 24 1 24H19C19.2652 24 19.5196 23.8946 19.7071 23.7071C19.8946 23.5196 20 23.2652 20 23V5C20 4.7348 19.8946 4.4804 19.7071 4.2929C19.5196 4.1054 19.2652 4 19 4ZM18 22H2V6H18V22ZM24 1V19C24 19.2652 23.8946 19.5196 23.7071 19.7071C23.5196 19.8946 23.2652 20 23 20C22.7348 20 22.4804 19.8946 22.2929 19.7071C22.1054 19.5196 22 19.2652 22 19V2H5C4.7348 2 4.4804 1.89464 4.2929 1.70711C4.1054 1.51957 4 1.26522 4 1C4 0.73478 4.1054 0.48043 4.2929 0.29289C4.4804 0.10536 4.7348 0 5 0H23C23.2652 0 23.5196 0.10536 23.7071 0.29289C23.8946 0.48043 24 0.73478 24 1Z"
                            fill="#323238"></path>
                    </svg>
                )
                }
                {isCopies && (
                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M99.8333 20.1264L30.4864 89.2233L0 58.8468L9.15941 49.72L30.4864 70.9705L90.6736 11L99.8333 20.1264Z" fill="#D9D9D9"/>
                    </svg>
                )}
            </div>
        </div>
    )
}
